import { blockedReasonOf } from "../../HistoryEntryRow/utils";
import { BLOCKED_LABEL_KEYS } from "../../HistoryEntryRow/ActionControl/constants";
import { buildHistorySentence } from "../buildHistorySentence";
import { formatRelativeTime } from "../formatRelativeTime";
import { isMacPlatform } from "utils/isMacPlatform";
import {
  NOTHING_LABEL_KEYS,
  SHORTCUT_KEYS_KEYS,
  SHORTCUT_LABEL_KEYS,
} from "../../constants";
import type { DescribeOwnUndoTarget } from "./types";

export const describeOwnUndoTarget: DescribeOwnUndoTarget = ({
  target,
  direction,
  currentUserEmail,
  locale,
  t,
}) => {
  if (target === null || target.action === null) {
    return { label: t(NOTHING_LABEL_KEYS[direction]), isRevertible: false };
  }

  const blockedReason = blockedReasonOf({
    action: target.action,
    direction,
    currentUserEmail,
    formatTime: (isoDate) =>
      formatRelativeTime({ isoDate, now: new Date(), locale }),
    adminLabel: t("smartSurveyor.history.admin"),
  });

  if (blockedReason !== null) {
    return {
      label: t(BLOCKED_LABEL_KEYS[direction], {
        reason: t(
          `smartSurveyor.history.blocked.${blockedReason.key}`,
          blockedReason.params,
        ),
      }),
      isRevertible: false,
    };
  }

  const { key, params } = buildHistorySentence({
    summary: target.summary,
    planCount: target.planCount,
    unknownTypeLabel: t("smartSurveyor.history.removedType"),
  });

  // Tooltips and toasts show plain text, so the bold markup of the drawer sentence is dropped.
  const sentence = t(`smartSurveyor.history.sentence.${key}`, params).replace(
    /<\/?b>/g,
    "",
  );

  const keys = t(
    SHORTCUT_KEYS_KEYS[isMacPlatform() ? "mac" : "other"][direction],
  );

  return {
    label: t(SHORTCUT_LABEL_KEYS[direction], { sentence, keys }),
    isRevertible: true,
  };
};
